var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravelaccommodation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 40,
    height: 40,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.984 22.4c0-1.344 0.032-2.592 0-3.84 0-0.16-0.192-0.32-0.32-0.448-3.648-2.912-7.296-5.824-10.944-8.704-0.352-0.256-0.512-0.544-0.48-0.992 0.032-1.056 0-2.144 0-3.2 0-1.376-0.96-2.368-2.24-2.368s-2.208 0.992-2.24 2.368c0 1.056-0.032 2.144 0 3.2 0.032 0.448-0.128 0.736-0.48 0.992-3.648 2.88-7.296 5.792-10.944 8.704-0.128 0.128-0.32 0.288-0.32 0.448-0.032 1.248 0 2.496 0 3.84l11.744-5.952v6.496c0 0.192-0.192 0.384-0.32 0.512-1.184 0.96-2.4 1.92-3.584 2.88-0.128 0.096-0.32 0.224-0.32 0.352-0.032 0.8 0 1.568 0 2.464 1.6-0.64 3.136-1.248 4.704-1.856 0 0.992 0.8 1.824 1.76 1.824s1.76-0.832 1.792-1.824c1.536 0.608 3.072 1.216 4.704 1.856 0-0.896 0-1.664-0.032-2.464 0-0.128-0.192-0.256-0.288-0.352-1.216-0.96-2.4-1.92-3.584-2.88-0.16-0.128-0.32-0.32-0.32-0.512-0.032-2.112-0.032-4.256-0.032-6.496 3.936 1.984 7.808 3.936 11.744 5.952z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelaccommodation);
export default __webpack_public_path__ + "static/media/travel&accommodation.e426b6876eeca205f05ef9e62b4f3c9b.svg";
export { ForwardRef as ReactComponent };